<template>
  <div>
    <div tabindex="0" @focus="focusLastDescendant($refs.privacyCenter.$el)"></div>
    <privacy-center ref="privacyCenter" :data="configuration" />
    <div tabindex="0" @focus="focusFirstDescendant($refs.privacyCenter.$el)"></div>
  </div>
</template>
<script>
import privacyCenter from '~privacyCenter';
import i18n from '~i18n';
// import configuration from '~configuration'; Will use one day for custom HTML perhaps
import { focusTrapMixin } from '@/common/mixins/focus-trap-mixin';
import { i18nMixin } from 'shared/i18n/i18n-mixin';

import { ifr } from '@/common/messaging/ifr';
export default {
  components: {
    privacyCenter,
  },
  mixins: [i18nMixin, focusTrapMixin],
  i18n,
  data() {
    return {
      configuration: {},
    };
  },
  mounted() {
    document.addEventListener('keyup', this.handleEscape);
  },
  methods: {
    handleEscape(event) {
      const key = event.which || event.keyCode;
      // Escape
      if (key === 27) {
        ifr.send('close', '"cross"');
      }
    },
  },
};
</script>
